var map = {
	"./JPEG.1.png": 178,
	"./JPEG.png": 179,
	"./JPEG0.5.jpg": 180,
	"./JPEG5.jpg": 181,
	"./background_start.jpg": 182,
	"./beach_dock.jpg": 183,
	"./bird.jpg": 184,
	"./bird1.jpg": 185,
	"./bird2.jpg": 186,
	"./bird3.jpg": 187,
	"./bird4.jpg": 188,
	"./books.png": 34,
	"./dark-paths.png": 189,
	"./data.png": 33,
	"./dog.jpg": 190,
	"./dog1.jpg": 191,
	"./dog2.jpg": 192,
	"./dog3.jpg": 193,
	"./dog4.jpg": 194,
	"./forrest.jpg": 195,
	"./hotel_spot.1.jpg": 196,
	"./hotel_spot.jpg": 197,
	"./landscape.1.jpg": 198,
	"./landscape.jpg": 199,
	"./lena.jpg": 200,
	"./lena1.jpg": 201,
	"./lena2.jpg": 202,
	"./lena3.jpg": 203,
	"./lena4.jpg": 204,
	"./lena5.jpg": 205,
	"./library.png": 45,
	"./multimedia.png": 206,
	"./polaroid.png": 207,
	"./sfulogo.jpg": 208,
	"./sfulogo.png": 43,
	"./squirrel.jpg": 209,
	"./squirrel1.jpg": 210,
	"./squirrel2.jpg": 211,
	"./squirrel3.jpg": 212,
	"./squirrel4.jpg": 213,
	"./textbook.jpg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;